<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <div class="h-screen flex overflow-hidden bg-gray-100">
    <!-- Static sidebar for desktop -->
    <div class="hidden md:flex md:flex-shrink-0">
      <div class="flex flex-col w-64">
        <!-- Sidebar component, swap this element with another sidebar if you like -->
        <div class="flex flex-col h-0 flex-1 bg-gray-800">
          <div class="flex-1 flex flex-col pt-5 pb-4 overflow-y-auto">
            <nav class="mt-5 flex-1 px-2 bg-gray-800 space-y-1">
              <template v-for="item in navigation">
                <Link v-if="!item.external"
                      :key="item.name"
                      :href="item.href"
                      :class="[item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white', 'group flex items-center px-2 py-2 text-sm font-medium rounded-md']"
                      :method="item.method ?? 'GET'">
                  <component :is="item.icon" :class="[item.current ? 'text-gray-300' : 'text-gray-400 group-hover:text-gray-300', 'mr-3 flex-shrink-0 h-6 w-6']" aria-hidden="true" />
                  {{ item.name }}
                </Link>
                <a v-else
                   :key="item.name"
                   :href="item.href"
                   :class="[item.current ? 'bg-gray-900 text-white' : 'text-gray-300 hover:bg-gray-700 hover:text-white', 'group flex items-center px-2 py-2 text-sm font-medium rounded-md']">
                  <component :is="item.icon" :class="[item.current ? 'text-gray-300' : 'text-gray-400 group-hover:text-gray-300', 'mr-3 flex-shrink-0 h-6 w-6']" aria-hidden="true" />
                  {{ item.name }}
                </a>
              </template>
            </nav>
          </div>
          <div v-if="lastImport"
               class="flex-shrink-0 flex">
            <ImportStatus :batch="lastImport" />
          </div>
        </div>
      </div>
    </div>
    <div class="flex flex-col w-0 flex-1 overflow-hidden">
      <main class="flex-1 relative z-0 overflow-y-auto focus:outline-none">
        <div class="py-6">
          <Header :class="{ [maxWidth]: true }">
            <slot name="header" />
          </Header>

          <div class="mx-auto px-4 sm:px-6 lg:px-8"
               :class="{ [maxWidth]: true }">
            <Alert v-for="(item) in flash"
                   :key="`flash-${item.id}`"
                   :message="item.message"
                   :type="item.type" />
          </div>

          <div class="mx-auto px-4 sm:px-6 lg:px-8"
               v-if="Object.keys(errors).length"
               :class="{ [maxWidth]: true }">

            <Alert message="There has been an error, please check your form" type="error" />
          </div>

          <div class="mx-auto px-4 sm:px-6 md:px-8"
               :class="{ [maxWidth]: true }">
            <slot />
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import * as icons from '@heroicons/vue/outline'
import { Link, usePage } from '@inertiajs/inertia-vue3'
import Alert from '@/components/alert'
import ImportStatus from '@/components/import-status'
import Header from '@/components/header'

export default {
  components: {
    ...icons,
    Link,
    Alert,
    ImportStatus,
    Header,
  },

  props: {
    maxWidth: {
      type: String,
      default: 'max-w-7xl',
    },
  },

  setup() {
    return {
      navigation: computed(() => usePage().props.value.navigation),
      flash: computed(() => usePage().props.value.flash),
      lastImport: computed(() => usePage().props.value.lastImport),
      errors: computed(() => usePage().props.value.errors),
    }
  },
}
</script>
